import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import useAgencyOrderBundle from '@hooks/useAgencyOrderBundle'
import { generateUrls } from '@hooks/useAgency'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { AgencyOrderBundleModel } from '@models/types'

const OrderBundleAgencyListItem = (props: { agencyOrderBundle: AgencyOrderBundleModel}) => {
  const { agencyOrderBundle: initAgencyOrderBundle, ...restProps } = props

  const { agency } = useAgencyOrderBundle(initAgencyOrderBundle)

  const { address_region, title: agencyTitle } = agency

  const { editAgencyUrl } = generateUrls({ id: agency.id })

  return (
    <DashboardModuleListItem
      secondaryText={address_region}
      title={agencyTitle}
      showCheckbox
      {...restProps}
    >

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

export default OrderBundleAgencyListItem
